<div class="relative">
  <div *ngIf="icon" class="absolute left-0 top-0 bottom-0 flex items-center justify-center pl-3">
    <img [ngSrc]="icon" class="w-6 h-6" [width]="24" [height]="24">
  </div>

  <div *ngIf="prepend" class="w-10 absolute text-gray-400 left-0 top-0 bottom-0 flex items-center text-center justify-center px-3 font-semibold text-xs border-r border-gray-200 text-center">
    {{ prepend }}
  </div>

  <input [type]="type"
         [formControl]="control"
         [attr.placeholder]="placeholder"
         [class.pl-12]="icon || prepend"
         class="h-[2.875rem] appearance-none w-full !outline-none text-sm placeholder-gray-400 !focus:outline-none rounded-lg bg-white px-4 py-3 border border-gray-200 transition-colors focus:border-primary-two">
</div>
